export const normalize = (state, arr) => {
    if (!arr || !arr.length)
        return state

    return arr.reduce((newState, item) => {
        const { id } = item
        const oldItem = state[id] || {}
        newState[id] = {
            ...oldItem,
            ...item
        }
        return newState
    }, {})
}


export const matchNormalize = (state, arr) => {
    if (!arr || !arr.length)
        return state
    const t = arr.reduce((newState, item) => {
        const { game_id, question_id } = item
        const oldItem = state[game_id] || {}
        newState[game_id+" "+question_id] = {
            ...oldItem,
            ...item
        }
        return newState
    }, {})
    return t
}


// WEBPACK FOOTER //
// ./src/utils/normalize.js